<template>
	<div class="poreguide">
		<Loading msg="loading" v-if="!isload" />
		<div class="guide_inner" v-else>
      		<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <div class="inner_up">
                    <div class="guide_title"><h1>护理要点/</h1><span class="title_tip">根据您的特征定制化护肤</span></div>
                    <ul class="detail_menu">
                        <template v-for="(title_item,title_idx) in guide_detail_obj[pore_solution_name]">
                        <li class="menu_item" :class="focused_idx == title_idx ? 'now' : ''" @click="changeFocusedTab(title_idx);ing_relative_index=0;triangle_left=30;" :ref="'focused_item_'+title_idx" :key="title_idx">{{title_item.detail.tag}}</li>
                        </template>
                        <!-- <li class="menu_item" :class="focused_idx == 1 ? 'now' : ''" @click="changeFocusedTab(1);" ref="focused_item_1">角栓</li> -->
                        <!-- <li class="menu_item" :class="focused_idx == 2 ? 'now' : ''" @click="changeFocusedTab(2);" ref="focused_item_2">日常防晒</li> -->
                        <span class="bg_div" :style="'width:' + focused_width + 'px;left:' + focused_left + 'px'"></span>
                    </ul>
                </div>
                <!-- 毛孔 控油 -->
                <template v-for="(detail_item,detail_idx) in guide_detail_obj[pore_solution_name]">
                    <div class="inner_down inner_down_first" v-if="focused_idx == detail_idx" :key="detail_idx">
                        <template v-if="detail_item.detail.mark">
                        <p class="inner_down_sub_text" v-html="detail_item.detail.suggest"></p>
                        <div class="ing_container_title">成分推荐</div>
                        <div class="ing_container" ref="ing_box" v-if="detail_item.detail.other && (detail_item.detail.other[0].ingredient) && (detail_item.detail.other[0].ingredient.length>0)">
                            <ul class="ing_list" ref="ing_list">
                                <li class="ing" :class="ing_relative_index==ing_idx ? 'now' : ''" :ref="'ing_'+ing_idx" @click="($parent.trackLog((actParams = { query: $route.query, pageid:499 }),{is_access:true,reportEvent_page_id:499,reportEvent_page_name:'毛孔-护理要点-成分',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'}));getTriangleLeft(ing_idx);ing_relative_index=ing_idx;" v-for="(ing,ing_idx) in detail_item.detail.other" :key="ing_idx"><img :src="ing.ingredient_img_url" :key="ing.ingredient_img_url" class="ing_pic" alt=""><div class="ing_name">{{ing.ingredient}}</div></li>
                                <!-- <li class="ing" ref="ing_1" @click="getTriangleLeft(1)"><img src="../assets/images/4.png" class="ing_pic" alt=""><div class="ing_name">假交替巴拉拉吧</div></li>
                                <li class="ing" ref="ing_2" @click="getTriangleLeft(2)"><img src="../assets/images/5.png" class="ing_pic" alt=""><div class="ing_name">假交替巴拉拉吧</div></li> -->
                               
                            </ul>
                        </div>
                        
                            <div class="ing_detail_outer" v-if="detail_item.detail.other && (detail_item.detail.other[0].ingredient) && (detail_item.detail.other[0].ingredient.length>0)">
                                <template v-for="(ing_detail,ing_detail_idx) in detail_item.detail.other">
                                    <div class="ing_detail" :key="ing_detail_idx" :class="ing_relative_index == ing_detail_idx ? 'now' : ''">
                                        <img src="../assets/images/triangle_icon.png" class="triangle_icon" ref="triangle_icon" :style="'left:'+triangle_left+'px'" alt="">
                                        <div class="ing_effect_name"><span>{{ing_detail.ingredient}}</span></div>
                                        <div class="ing_effect_title">成分功效</div>
                                        <p class="ing_effect_text">{{ing_detail.effect}}</p>
                                        <div class="ing_pro_title">含有该成分的护肤品</div>
                                        <div class="ing_pro_related" v-if="ing_detail.ingredient && (ing_detail.ingredient.length > 0)">
                                            <!-- 存在uniskin产品 -->
                                            <!-- @click="$parent.goMallDetail(ing_detail.products_desc[0].uniskin_goods_id)" -->
                                            <div class="self_pro" v-show="ing_detail.products.includes('优时颜')">
                                                <img :src="ing_detail.products_desc[0].img_url" class="self_pic" alt="">
                                                <div class="self_info">
                                                    <div class="self_name">{{ing_detail.products_desc[0].name}}</div>
                                                    <div class="self_introduce" >{{ing_detail.products.includes('优时颜净能') ? '净能控油精萃乳是一款多通路干预皮脂生成，解决面部油光根源问题的产品，' : '基于护肤水即时舒缓、帮助后续产品吸收的功能特性，在开发平衡水时重点'}}
                                                    <div class="text_remaining" :class="text_remaining_show ? 'now' : ''" @click="text_remaining_show=!text_remaining_show" v-show="ing_detail.products.includes('优时颜净能')">相对于传统的添加矿物粉成分的控油功效产品，把控油的机理从“吸附”变为“作用”，即使是素颜状态，也可以让面部不泛油光，毛孔更加细腻。</div>
                                                    <div class="text_remaining" :class="text_remaining_show ? 'now' : ''" @click="text_remaining_show=!text_remaining_show" v-show="!(ing_detail.products.includes('优时颜净能'))">关注了它的吸收性、温和性和保湿性，而美白、抗皱等功能则需要通过后续精华产品来达到。</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul class="oth_pros" v-show="!((ing_detail.products_desc.length == 1) && ing_detail.products.includes('优时颜'))">
                                                <template v-for="(oth_pro,oth_idx) in ing_detail.products_desc">
                                                <li class="oth_pro" :key="oth_idx" v-show="!oth_pro.name.includes('优时颜')"><img :src="oth_pro.img_url" :key="oth_pro.img_url" class="oth_pro_pic" alt=""><div class="oth_pro_name">{{oth_pro.name}}</div></li>
                                                </template>
                                                <!-- <li class="oth_pro"><img src="../assets/images/Mask.png" class="oth_pro_pic" alt=""><div class="oth_pro_name">OLAY小白瓶</div></li> -->
                                            </ul>
                                        </div>
                                          <!-- 查看其他产品列表按钮 -->
                                        <div class="ing_pro_related_check"><span @click="($parent.trackLog((actParams = { query: $route.query, pageid:500 }),{is_access:true,reportEvent_page_id:500,reportEvent_page_name:'毛孔-护理要点-产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'}));checkOthPro(ing_detail.products_desc)">查看产品详情</span></div>
                                    </div>
                                 </template>
                            </div>
                       
                    </template>
                    <!-- 没有成分信息时  简短页面-->
                    <template v-else>
                        <div class="guide_detail_when_short">
                            <img :src="detail_item.detail.img_short" class="guide_detail_when_short_img" alt="">
                            <p class="guide_detail_when_short_explain" v-if="detail_item.detail.suggest_text_short" v-html="detail_item.detail.suggest_text_short"></p>
                            <ul class="guide_detail_when_short_ul" v-if="detail_item.detail.list_text_short" :class="!detail_item.detail.suggest_text_short ? 'now' : ''">
                                <li class="guide_detail_when_short_list" v-for="(short_list,short_idx) in detail_item.detail.list_text_short" :key="short_idx">{{short_list}}</li>
                            </ul>
                            
                            <!-- <div class="guide_detail_when_short_list">无论室内室外、雨天晴天，都要注意使用防晒措施。</div> -->
                        </div>

                    </template>
                    </div>
                </template>


             

		
		</div>

        <!-- 其他产品列表弹窗 -->
        <transition name="fade">
            <div class="oth_rec_layer" v-if="show_oth_pro_list">
                <div class="layer_inner">
                    <img src="../assets/images/close_btn.svg" class="close_icon" alt="" @click="show_oth_pro_list =false">
                    <div class="layer_title">产品列表</div>
                    <ul class="layer_pro_list">
                    <li class="layer_pro" v-for="(oth_pro_item,oth_pro_idx) in check_oth_pro_list" :key="oth_pro_idx" @click="oth_pro_item.uniskin_goods_id && $parent.goMallDetail(oth_pro_item.uniskin_goods_id);">
                        <div class="layer_pro_check_btn" v-if="oth_pro_item.uniskin_goods_id">
                            <span>去购买</span>
                            <img src="../assets/images/arrow_right_d.svg" class="layer_pro_check_icon" alt="" v-if="oth_pro_item.uniskin_goods_id">
                        </div>
                        <!-- <img src="../assets/images/arrow_right_d.svg" class="layer_pro_check_icon" alt="" v-if="oth_pro_item.go_mall"> -->

                        <img :src="oth_pro_item.img_url" class="pro_pic" alt="">
                        <div class="pro_detail">
                            <div class="pro_name">{{oth_pro_item.name}}</div>
                            <div class="pro_ing"><span>功效:</span><span class="ing_item" v-for="(effect,e_idx) in oth_pro_item.effect.split(' ')" :key="e_idx">{{effect}}</span></div>
                            <div class="pro_price" v-html="'参考价格:'+oth_pro_item.price"></div>
                        </div>
                    </li>
                    <!-- <li class="layer_pro">
                        <img src="../assets/images/Cream.png" class="pro_pic" alt="">
                        <div class="pro_detail">
                            <div class="pro_name">优时颜控油精华</div>
                            <div class="pro_ing"><span>功效</span><span class="ing_item">黄瓜果提取物</span><span class="ing_item">透明质酸钠</span></div>
                            <div class="pro_price">参考价格:&yen;<span>&yen;388/50ml</span></div>
                        </div>
                    </li> -->
 
                    </ul>

                </div>
            </div>
        </transition>

 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
import { setTimeout } from 'timers';
var wx = require("weixin-js-sdk");
export default {
  name: "PoreGuideAreaDetailDescription",
  data() {
    return {
      isload: false,
      focused_idx:0,
      focused_left:0,
      focused_width:0,
      triangle_left:30,  //成分详情icon
      in_weapp: false, //是否在小程序
      guide_area_detail_data:null,
      guide_title_obj:{t_solution:[],v_solution:[]},    //tag 对应标题 （T区+脸颊）
      guide_detail_obj:{t_solution:[],v_solution:[]},   //护理详情  (T区+脸颊)
      detail_tag_name:"",  //单项tag名称 上级页面传递参数
      detail_tag_index:"", //单项tag 对应index  上级页面传参
      ing_relative_index:0,  //成分对应详情index
      show_rec:true,  //早晚护肤列表
      show_oth:false,  //对应类型产品
      pore_solution_name:"",  //T区或脸颊v_solution/t_solution
      check_oth_pro_list:null,  //查看其他产品列表
      show_oth_pro_list:false,  // 展示其他产品列表
      text_remaining_show:false
    };
  },

  created() {
    console.log("skincareguideareadetaildescription created", this);
    this.initPoreGuide();
    this.detail_tag_name= this.$route.query.detail;
    this.detail_tag_index = this.$route.query.detail_index;
    this.focused_idx = this.$route.query.detail_index;
    console.log('detail_tag_name',this.detail_tag_name);
    console.log('detail_tag_index',this.detail_tag_index);
  },
  mounted() {
        setTimeout(() => {
			this.changeFocusedTab(this.focused_idx);
		}, 500);
      
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
        checkOthPro:function(oths){
          this.check_oth_pro_list = oths;
          this.show_oth_pro_list = true;
      },
      getTriangleLeft:function(index){
          console.log('this.$refs',this.$refs);
          this.triangle_left = this.$refs['ing_'+index][0].offsetLeft - this.$refs['ing_box'][0].scrollLeft -10;
        // this.triangle_left = this.$refs['ing_box'].scrollLeft;
        if(this.triangle_left < 30){
            this.triangle_left = 30;
        }
      },
        changeFocusedTab: function(idx) {
            let that = this;
			that.focused_idx = idx;
			console.log(271, that.$refs['focused_item_' + idx]);
            setTimeout(() =>{
                that.focused_width = that.$refs['focused_item_' + idx][0].clientWidth;
			    that.focused_left = that.$refs['focused_item_' + idx][0].offsetLeft;
            });
			
            console.log(that.focused_width,that.focused_left);
		},
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    initPoreGuide: function() {
      let that = this;
      var local_pore_area_detail_desc_guide = JSON.parse(localStorage.getItem("local_pore_area_detail_desc_guide"));
      if (local_pore_area_detail_desc_guide) {
        afterPoreGuide(local_pore_area_detail_desc_guide);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getPoreSolution"
          )
          .then(json => {
            console.log(json);
            afterPoreGuide(json);
            // localStorage.setItem("local_pore_area_detail_desc_guide",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterPoreGuide(guide_area_detail_data) {
        if (guide_area_detail_data.code == 0) {
          that.isload = true;
          that.guide_area_detail_data = guide_area_detail_data.data;
            if(that.$route.query.solution == 't_solution'){
                //  that.pore_solution_type = "type"+guide_area_detail_data.data.T_solution;
                //  that.guide_area_title = "T区护理";
                 that.pore_solution_name = "t_solution";
            }else if(that.$route.query.solution == 'v_solution'){
                //  that.pore_solution_type = "type"+guide_area_detail_data.data.face_solution;
                //  that.guide_area_title = "脸颊护理";
                 that.pore_solution_name = "v_solution";
            }

            // alert("poresolution_type"+that.pore_solution_name);
            var guide_total_data_t = guide_area_detail_data.data.T_desc[0];
            var guide_total_data_v = guide_area_detail_data.data.face_desc[0];
            for(let v in guide_total_data_t){
                console.log(v);
                console.log(guide_area_detail_data.data.T_desc[0][v]);
                if(guide_total_data_t[v].tag == "控油"){
                    guide_total_data_t[v].suggest =  guide_total_data_t[v].suggest.split("<br>")[0];
                }else if(guide_total_data_t[v].tag == "补水保湿"){
                     guide_total_data_t[v].suggest =  guide_total_data_t[v].suggest.split("<br>")[0];
                }else if(guide_total_data_t[v].tag == "去角栓"){
                     guide_total_data_t[v].suggest =  guide_total_data_t[v].suggest.split("<br>")[0];
                }else if(guide_total_data_t[v].tag == "抗衰"){
                     guide_total_data_t[v].suggest =  guide_total_data_t[v].suggest.split("<br>")[0];
                }
                //没有成分及其他详细描述的 不做展示
                // if(guide_total_data_t[v].other[0].ingredient.length > 0){
                //    that.guide_detail_obj.t_solution.push({title:v,detail:guide_total_data_t[v]});
                // }
                //修改为 没有成分信息 添加标识mark
                if(guide_total_data_t[v].other[0].ingredient.length > 0){
                    guide_total_data_t[v].mark = true;
                }else{
                    guide_total_data_t[v].mark = false;
                    //没有成分信息时  对应新页面添加新字段
                    let t_suggest_text_short =  guide_total_data_t[v].suggest.split("|")[0];
                    let t_list_text_short =  guide_total_data_t[v].suggest.split("|")[1];
                    let t_img_short =  guide_total_data_t[v].suggest.split("|")[2];
                    if(!t_suggest_text_short.includes('split')){
                        guide_total_data_t[v].suggest_text_short = t_suggest_text_short;
                    };
                    if(!t_list_text_short.includes("split")){
                         guide_total_data_t[v].list_text_short = t_list_text_short.split("arr");
                    }
                     guide_total_data_t[v].img_short = t_img_short;
                }
                 that.guide_detail_obj.t_solution.push({title:v,detail:guide_total_data_t[v]});
            }
            for(let v in guide_total_data_v){
                console.log(v);
                console.log(guide_area_detail_data.data.face_desc[0][v]);
                if(guide_total_data_v[v].tag == "控油"){
                    guide_total_data_v[v].suggest =  guide_total_data_v[v].suggest.split("<br>")[0];
                }else if(guide_total_data_v[v].tag == "补水保湿"){
                     guide_total_data_v[v].suggest =  guide_total_data_v[v].suggest.split("<br>")[0];
                }else if(guide_total_data_v[v].tag == "去角栓"){
                     guide_total_data_v[v].suggest =  guide_total_data_v[v].suggest.split("<br>")[0];
                }else if(guide_total_data_v[v].tag == "抗衰"){
                     guide_total_data_v[v].suggest =  guide_total_data_v[v].suggest.split("<br>")[0];
                }
                //没有成分及其他详细描述的 不做展示
                // if(guide_total_data_v[v].other[0].ingredient.length > 0){
                //    that.guide_detail_obj.v_solution.push({title:v,detail:guide_total_data_v[v]});
                // }
                //修改为 没有成分信息 添加标识mark
                if(guide_total_data_v[v].other[0].ingredient.length > 0){
                    guide_total_data_v[v].mark = true;
                }else{
                    guide_total_data_v[v].mark = false;
                    //没有成分信息时  对应新页面添加新字段
                    let v_suggest_text_short =  guide_total_data_v[v].suggest.split("|")[0];
                    let v_list_text_short =  guide_total_data_v[v].suggest.split("|")[1];
                    let v_img_short =  guide_total_data_v[v].suggest.split("|")[2];
                    if(!v_suggest_text_short.includes('split')){
                        guide_total_data_v[v].suggest_text_short = v_suggest_text_short;
                    };
                    if(!v_list_text_short.includes("split")){
                         guide_total_data_v[v].list_text_short = v_list_text_short.split("arr");
                    }
                     guide_total_data_v[v].img_short = v_img_short;
                }
                 that.guide_detail_obj.v_solution.push({title:v,detail:guide_total_data_v[v]});
            }
              console.log('guide_title_obj',that.guide_title_obj);
              console.log('guide_detail_obj',that.guide_detail_obj);

        }
      }
    },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";

//查看其他产品列表
.oth_rec_layer{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.2);
    .layer_inner{
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        width:690/50rem;
        height:1033/50rem;
        .border-radius(14/50rem);
        .shadow;
        background:@bg_c_l;
        box-sizing:border-box;
        padding:45/50rem 20/50rem 45/50rem 0;
        .close_icon{
            position:absolute;
            top:52/50rem;
            right:30/50rem;
            width:30/50rem;
            height:30/50rem;
        }
        .layer_title{
            padding:0 0 60/50rem 30/50rem;
            font-size:44/50rem;
            line-height:1em;
            font-weight:bold;
        }
    }
}
.layer_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    position:relative;
    .layer_pro_check_icon{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
        width:27/50rem;
        height:27/50rem;
    }
    .layer_pro_check_btn{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
        width:14/50rem;
        height:27/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            .align-self_center;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-detail;
            padding-right:30/50rem;
            white-space:nowrap;
        }
        img{
            .align-self_center;
            width:27/50rem;
            height:27/50rem;
        }
    }
    .pro_pic,.pro_detail{
        .align-self_flex-start;
    }
    .pro_pic{
        width:163/50rem;
    }
    .pro_detail{
        padding:16/50rem 50/50rem 55/50rem 0;
        margin-bottom:29/50rem;
        width:494/50rem;
        border-bottom:1px solid @font-c-detail;
        .pro_name{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-bottom:23/50rem;
        }
        .pro_ing{
            .display_flex;
            .justify-content_flex-start;
            span{
                .flex_0;
                font-size:24/50rem;
                line-height:1em;
                color:@font-c-9;
                &.ing_item{
                    padding-right:20/50rem;
                }
            }
            
        }
        .pro_price{
            padding-top:16/50rem;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-9;
        }
    }
}
.layer_pro_list{
    height:863/50rem;
    -webkit-overflow-y:scroll;
    overflow-y:scroll;
    box-sizing:border-box;
}
.layer_pro_list .layer_pro:last-child{
    .pro_detail{
        border-bottom:1px solid transparent;
    }
}
// 没有成分信息时详情
.guide_detail_when_short{
    padding-right:30/50rem;
    text-align:center;
    .guide_detail_when_short_img{
        .border-radius(14/50rem);
        .shadow;
        width:520/50rem;
        height:321/50rem;
    }
    .guide_detail_when_short_explain{
        padding:32/50rem 0 8/50rem;
        font-size:26/50rem;
        line-height:34/50rem;
        color:@font-c-6;
        text-align:left;
    }
    .guide_detail_when_short_ul{
        &.now{
            margin-top:32/50rem
        }
    }
    .guide_detail_when_short_list{
        position:relative;
        padding:0 0 18/50rem 22/50rem;
        font-size:26/50rem;
        line-height:34/50rem;
        color:@font-c-6;
        text-align:left;
        &::before{
            content:"";
            display:block;
            position:absolute;
            width:10px;
            height:10px;
            .border-radius(50%);
            background:@font-c-0;
            top:8/50rem;
            left:0;
            -webkit-transform:scale(0.5);
            transform:scale(0.5);
        }

    }
}

.guide_inner{
    background:@bg_c_m;
    padding:0 0 169/50rem;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}
.inner_up{
    padding:106/50rem 30/50rem 0;
    background:@font-c-f;
    .shadow;
    .guide_title{
        padding-bottom:80/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        h1,.title_tip{
            .align-self_flex-end;
        }
        h1{
            font-size:44/50rem;
            font-weight:bold;
            line-height:1em;
            margin-right:17/50rem;
            color:@font-c-3;
        }
        .title_tip{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-detail;
        }
    }
    .detail_menu {
    position:relative;
    box-sizing: border-box;
    // .shadow;
    // padding: 81/50rem 30/50rem 0/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    .menu_item {
    -webkit-tap-highlight-color:transparent; 
      padding-bottom: 10/50rem;
      margin-right:50/50rem;
      .align-items_flex-end;
      .flex_0;
    //   width: 33.33%;
      font-size: 30/50rem;
      line-height: 1em;
      text-align: center;
      color: @font-c-detail;
      border-bottom: 3px solid transparent;
      &.now {
        font-size: 34/50rem;
        font-weight: bold;
        color:@font-c-detail;
        // border-bottom: 3px solid #f099a6;
      }
    }
  }
    .bg_div{
    position:absolute;
    bottom:0;
    height:3px;
    width:1/50rem;
    background:@font-c-detail;
    -webkit-transition:left 0.5s;
    transition:left 0.5s;
    }
}
.inner_down{
    padding:52/50rem 0 119/50rem 30/50rem;
    .inner_down_sub_text{
        padding-right:30/50rem;
        font-size:24/50rem;
        line-height:30/50rem;
        color:@font-c-6;
    }
    .ing_container_title{
        padding-top:47/50rem;
        font-size:34/50rem;
        line-height:1em;
        font-weight:bold;
        color:@font-c-3;
    }
}
.ing_container{
    padding:30/50rem 0 55/50rem;
    width:100%;
    -webkit-overflow-x:scroll;
    overflow-x:scroll;
    &::-webkit-scrollbar{
        display:none;
    }
    .ing_list{
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        &::after{
            content:"";
            display:block;
            opacity:0;
            width:1px;
            height:1px;
            .flex_0;
        }
        .ing{
            .flex_0;
            margin-right:20/50rem;
            box-sizing:border-box;
            padding:0 0 23/50rem;
            .border-radius(14/50rem);
            .shadow;
            background:@font-c-f;
            width:180/50rem;
            height:180/50rem;
            &.now{
                background:#FFE4E4;
            }
            .ing_pic{
                width:100%;
            }
            .ing_name{
                padding:0 30/50rem;
                text-align:center;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                font-size:24/50rem;
                // line-height:1em;
                color:@font-c-3;
            }
        }
    }
}
.ing_detail_outer{
    padding-right:30/50rem;
    .ing_detail{
        display:none;
        position:relative;
        .border-radius(14/50rem);
        .shadow;
        background:@bg_c_l;
        padding:40/50rem 30/50rem 48/50rem;
        .triangle_icon{
            position:absolute;
            width:60/50rem;
            height:20/50rem;
            top:-20/50rem;
            left:70/50rem;
        }
        .ing_effect_title{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-detail;
        }
        .ing_effect_name{
            padding-bottom:30/50rem;
            .display_flex;
            .flex-wrap_nowrap;
            .justify-content_flex-start;
            span{
                .flex_0;
                font-size:30/50rem;
                line-height:1.1em;
                font-weight:bold;
                color:@font-c-3;
                border-bottom:1px solid @font-c-3;
            }
        }
        .ing_effect_text{
            padding:9/50rem 0 41/50rem;
            font-size:24/50rem;
            line-height:30/50rem;
            color:@font-c-6;
        }
        .ing_pro_title{
            padding-bottom:30/50rem;
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-detail;
        }
        &.now{
            display:block;
        }
    }
}
.ing_pro_related{
    background:@font-c-f;
    .shadow;
    .border-radius(14/50rem);
    padding:28/50rem 25/50rem 58/50rem;
}
.ing_pro_related_check{
    padding-top:25/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-end;
    span{
        .flex_0;
        font-size:26/50rem;
        line-height:1em;
        color:@font-c-detail;
        border-bottom:1px solid @font-c-detail;
    }
}
.self_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    border-bottom:1px solid @font-c-detail;
    padding-bottom:40/50rem;
    .self_pic{
        width:163/50rem;
        height:163/50rem;
    }
    .self_info{
        padding-top:11/50rem;
        .self_name{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-bottom:16/50rem;
        }
        .self_introduce{
            font-size:24/50rem;
            line-height:30/50rem;
            color:@font-c-9;
            .text_remaining{
                position:relative;
                padding-bottom:40/50rem;
                font-size:24/50rem;
                line-height:30/50rem;
                color:@font-c-9;
                width:411/50rem;
                overflow:hidden;
                white-space:nowrap;
                text-overflow:ellipsis;
                &::after{
                    content:"展开";
                    display:block;
                    position:absolute;
                    right:0;
                    bottom:0/50rem;
                    font-size:24/50rem;
                    line-height:30/50rem;
                    color:@font-c-detail;
                }
                &.now{
                    overflow:unset;
                    white-space:unset;
                    text-overflow:unset;
                        &::after{
                        content:"收起";
                        display:block;
                        position:absolute;
                        right:0;
                        bottom:0/50rem;
                        font-size:24/50rem;
                        line-height:30/50rem;
                        color:@font-c-detail;
                    }
                }
            }
        }
    }
}
.oth_pros{
    .display_flex;
    .justify-content_flex-start;
    -webkit-overflow-x:scroll;
    overflow-x:scroll;
    .oth_pro{
        padding-top:30/50rem;
        margin-right:30/50rem;
        .oth_pro_pic{
            width:150/50rem;
            height:150/50rem;
            .border-radius(50%);
            .shadow;
            background:#efefef;
        }
        .oth_pro_name{
            text-align:center;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-top:15/50rem;
            width:150/50rem;
            overflow:hidden;
            white-space:nowrap;
            text-overflow:ellipsis;
        }
    }
    &::after{
        content:"";
        display:block;
        opacity:0;
        width:5px;
        height:1px;
        .flex_0;
    }
}
.inner_down_first{

}
.inner_down_second{
    .oth_pro{
        padding-top:0;
    }
}
.inner_down_third{
    padding:52/50rem 30/50rem 119/50rem;
    .ing_detail_outer{
        padding-right:0;
        .ing_detail{
            .border-radius(0);
            padding:30/50rem 0 48/50rem;
            background:transparent;
            -webkit-box-shadow:0 0 0 0 transparent;
            -moz-box-shadow:0 0 0 0 transparent;
            box-shadow:0 0 0 0 transparent;
        }
    }
    .oth_pro{
        padding-top:0;
    }
}

</style>
